let store = null;

export function setStore(storeInstance) {
  store = storeInstance;
}

export function getStore() {
  return store;
}
